import { APP_LINKS, FEATURES } from "../constants/site";
import { Seo } from "../components/site/Seo";
import { Reveal, SectionHead } from "../components/site/Shared";
import { Icon } from "../components/site/Icon";

export default function Features() {
  return (
    <>
      <Seo
        title="Features — Assets, Documents, Warranties, Services & AI"
        description="Explore HomeAligns features: household asset management, multiple properties, warranty and document tracking, maintenance reminders, service bookings, family sharing, AI scanning, value insights and more."
        path="/features"
      />
      <section className="container-site py-20 lg:py-24">
        <SectionHead
          level={1}
          eyebrow="Features"
          title="Everything your home needs. Aligned in one place."
          sub="Assets, documents, warranties, smart reminders, money management and trusted services — one app for your whole household. Everything below is live in HomeAligns today unless marked coming soon."
        />
        <div className="grid gap-6 md:grid-cols-2">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 2) + 1} className="card-site p-8">
              <div className="flex items-start gap-5">
                <span className="icon-tile mt-0.5 shrink-0">
                  <Icon name={f.icon} className="h-5 w-5" />
                </span>
                <div>
                  <h2 className="text-lg font-bold text-ink">{f.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-ink/60">{f.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-12 flex flex-wrap gap-4">
          <a href={APP_LINKS.getStarted} data-testid="features-get-started-btn" className="btn-primary">
            Get Started <Icon name="ArrowRight" className="h-4 w-4" />
          </a>
          <a href={APP_LINKS.login} data-testid="features-login-btn" className="btn-secondary">
            Log In
          </a>
        </Reveal>
      </section>
    </>
  );
}
